import { NewsAbstraction, withCommonNews } from './NewsAbstract';
class NewsSearch extends NewsAbstraction {

    protected renderNewsContent(): JSX.Element {
        const config = this.props.appServices.config;

        return (
            <news-article-search
                id="newsSearchMfe"
                bff-base-url={config.newsBffBaseUrl}
                mfe-base-url={`${config.newsSearchBaseUrl}/news-article-search`}
                article-details-url={config.newsOpenedArticleUrl}
                article-impact-data-api-url={`${config.toxnotWebAppUrlEndpoint}/Api/GetArticleImpact`} 
                customer-filter-api-url={`${config.toxnotWebAppUrlEndpoint}/Api/GetCasNumbersByMaterialNames`}
                show-portfolio-panel="no"
                show-portfolio-products-filter="yes"
                show-portfolio-custom-lists-filter="no"
                locale="en">
            </news-article-search>
        );
    }
}

export default withCommonNews(NewsSearch);
